<template>
    <v-container>
        <v-row
                justify="center"
        >
            <v-col
                    class="mx-auto"
                    cols="12"
                    md="6">
                <v-form
                        method="post"
                        @submit.prevent="handleSubmit"
                        ref="form"
                        lazy-validation
                >
                    <v-card
                            class="pa-2"
                            outlined
                            tile>
                        <v-card-title>
                            {{ title }}
                        </v-card-title>
                        <v-text-field
                                label="E-Mail"
                                type="email"
                                v-model="email"
                                :rules="[rules.required]"
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="password"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="show ? 'text' : 'password'"
                                name="input-10-1"
                                label="Passwort"
                                hint="Das Passwort muss mindestens 8 Zeichen enthalten"
                                counter
                                @click:append="show = !show"
                        >
                        </v-text-field>
                    </v-card>
                    <v-btn
                            color="primary"
                            class="mt-3"
                            type="submit"
                            
                    >Anmelden</v-btn>
                    <Registrieren></Registrieren>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Registrieren from "../Forms/Registrieren";

    export default {
        name: 'LogIn',
        apollo: {
            $client: 'apolloClientB'
        },
        data (e) {
            return {
                title: e.$t('greeting'),
                email: '',
                password: '',
                show: false,
                rules: {
                    required: value => !!value || 'Pflichtfeld',
                    min: v => v.length >= 8 || 'Das Passwort ist zu kurz!'
                },
            }
        },
        methods: {
            handleSubmit () {
                this.submitted = true;
                const { email, password } = this;
                const { dispatch } = this.$store;
                if (email && password) {
                    dispatch('authentification/login', { email, password });
                }
            }
        },
         components: {
            Registrieren
        }
    }
</script>
